import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { DEPLOY, GET_CURRENCY } from "@store/operations/customOperations";

export const useDeploy = () => useMutation(DEPLOY);

export const useCurrency = () => useQuery(GET_CURRENCY);
